export default __webpack_public_path__ + "static/media/chat-info-outline.95ce7e91.svg";